import handler from 'api/handler'

const prefix = '/public/donation'

const methods = {
  create: args => handler({ method: 'post', url: `${prefix}/create`, args }),
  verify: args => handler({ method: 'post', url: `${prefix}/verify`, args }),
  recordOffline: args => handler({ method: 'post', url: `${prefix}/recordOffline`, args }),
  checkout: args => handler({ method: 'post', url: `${prefix}/checkout`, args }),
  settings: args => handler({ method: 'get', url: `${prefix}/settings`, args }),
  updateReceiptNumber: args => handler({ method: 'post', url: `${prefix}/updateReceiptNumber`, args }),
  downloadReceipt: async (id) => {
    try {
      // Use the full backend URL to avoid any routing issues
      const url = `http://localhost:8080/api/public/donation/receipt/${id}`
      
      console.log('Downloading receipt from:', url)
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Backendaccesskey': process.env.REACT_APP_BACKEND_ACCESS_KEY,
          'Origin': window.location.origin,
          'Content-Type': 'text/html'
        },
        mode: 'cors'
      })
      
      console.log('Response status:', response.status)
      console.log('Response headers:', response.headers)
      
      if (!response.ok) {
        throw new Error(`Failed to download receipt: ${response.status} ${response.statusText}`)
      }
      
      const text = await response.text()
      console.log('Received content length:', text.length)
      console.log('Content preview:', text.substring(0, 100))
      
      // Create blob from the text content
      const blob = new Blob([text], { type: 'text/html' })
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `donation-receipt-${id}.html`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(downloadUrl)
      
      console.log('Receipt downloaded successfully')
    } catch (error) {
      console.error('Error downloading receipt:', error)
      // Fallback: Open receipt in new window
      try {
        const viewUrl = `http://localhost:8080/api/public/donation/view-receipt/${id}`
        window.open(viewUrl, '_blank')
        alert('Receipt opened in new window. You can print or save it from there.')
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError)
        alert(`Failed to download receipt: ${error.message}`)
      }
    }
  }
}

export default methods


